import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { InputRow, SelectRow } from "../Rows";
import { FormCard } from "../FormCard";
import OcpiModulesList from "./OcpiModulesList";
import { withTranslatedLabels } from "../../i18n/options";

export const OCPI_PARTY_MODULES = [
    { label: "Cdrs", value: "cdrs" },
    { label: "Commands", value: "commands" },
    { label: "Credentials", value: "credentials" },
    { label: "Locations", value: "locations" },
    { label: "Sessions", value: "sessions" },
    { label: "Tariffs", value: "tariffs" },
    { label: "Tokens", value: "tokens" },
    { label: "Booking", value: "Booking" },
];

export const VERSION_OPTIONS = [
    { value: "2.2.1", label: "2.2.1" },
    { value: "2.3.0", label: "2.3.0" },
];

const HandshakePartyForm = ({
    form,
    onFieldChange,
    onVersionChange,
    customers = [],
    invalidFields = [],
}) => {
    const { t } = useTranslation();
    const visibleModules = useMemo(() => {
        const modules =
            form.versionNumber === "2.3.0"
                ? OCPI_PARTY_MODULES
                : OCPI_PARTY_MODULES.filter((m) => m.value !== "Booking");
        return withTranslatedLabels(modules, t, "ocpiParty.module");
    }, [form.versionNumber, t]);

    const customerOptions = customers.map((customer) => ({
        value: customer.customerPublicId,
        label: customer.displayName || customer.name,
    }));

    return (
        <>
            <InputRow
                label={t("common.name")}
                value={form.remotePartyName}
                onChange={(v) => onFieldChange("remotePartyName", v)}
                invalid={invalidFields.includes("remotePartyName")}
            />
            <SelectRow
                label={t("entity.customer")}
                options={customerOptions}
                value={form.customerPublicId || null}
                isClearable={true}
                onChange={(v) => onFieldChange("customerPublicId", v ?? "")}
                invalid={invalidFields.includes("customerPublicId")}
            />
            <InputRow
                label={t("form.decodedTokenA")}
                value={form.emspDecodedTokenA}
                onChange={(v) => onFieldChange("emspDecodedTokenA", v)}
                invalid={invalidFields.includes("emspDecodedTokenA")}
            />
            <InputRow
                label={t("form.emspVersionsUrl")}
                value={form.emspVersionsUrl}
                onChange={(v) => onFieldChange("emspVersionsUrl", v)}
                invalid={invalidFields.includes("emspVersionsUrl")}
            />
            <SelectRow
                label={t("form.version")}
                options={VERSION_OPTIONS}
                value={form.versionNumber}
                onChange={onVersionChange}
                invalid={invalidFields.includes("versionNumber")}
            />
            <FormCard
                title={t("form.ocpiModules")}
                className="max-w-3xl !p-5 shadow-md md:col-start-1"
                titleClassName="text-lg"
                description={t("ocpiParty.modulesDescription")}
            >
                <OcpiModulesList
                    modules={visibleModules}
                    selected={form.identifiers}
                    onChange={(next) => onFieldChange("identifiers", next)}
                />
                {invalidFields.includes("identifiers") && (
                    <p className="text-sm text-red-500 mt-2">{t("ocpiParty.selectAtLeastOneModule")}</p>
                )}
            </FormCard>
        </>
    );
};

export default HandshakePartyForm;
